import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Spinner } from "reactstrap";

type FullPageSpinnerProps = {
    delayMs?: number;
    text?: string;
}

const FullPageSpinner = ({delayMs, text}: FullPageSpinnerProps) => {
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    
    useEffect(() => {
        if (showSpinner) {
            document.getElementsByTagName('body')[0].style.paddingRight = "0";
            document.getElementsByTagName('body')[0].style.overflow = "hidden";
        }

        return () => { document.getElementsByTagName('body')[0].style.overflow = "auto"; };
    } ,[showSpinner])

    setTimeout( () => {
        setShowSpinner(true);
    }, delayMs ?? 200)

    return showSpinner ? ReactDOM.createPortal(<Backdrop text={text}/>, portalElement!) : null;
}

type BackdropProps = {
    text?: string;
}

const Backdrop = ({text}: BackdropProps) => {
    return <div className="full-page-spinner__backdrop">
        <div className="full-page-spinner__spinner mb-3">
            <Spinner
                style={{
                    height: '5rem',
                    width: '5rem'
                }} />
        </div>
        <h2 className="text-primary text-large mt-3">{ text ?? "Please wait"}</h2>
    </div>;
}

const portalElement = document.getElementById('overlays');

export default FullPageSpinner;